import React from 'react'

const EmptyBoxSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="130"
      height="81"
      viewBox="0 0 130 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.8"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.574 15.7281C27.9 11.5361 29.134 8.92605 30.274 7.89705C33.431 5.04905 37.796 6.59905 38.724 6.82105C41.984 7.60305 40.924 2.45705 43.721 1.41105C45.585 0.714054 47.118 1.56605 48.321 3.96705C49.386 1.72705 51.009 0.701054 53.19 0.884054C56.462 1.16105 57.607 12.2121 62.103 9.79305C66.6 7.37305 72.113 6.82005 74.468 10.4161C74.977 11.1941 75.172 9.98705 78.634 5.86605C82.096 1.74405 85.548 -0.0719463 92.63 2.32805C95.85 3.41805 98.498 6.37305 100.577 11.1921C100.577 18.0701 105.637 22.1421 115.755 23.4051C130.934 25.3001 119.152 41.6191 100.577 46.3981C82.001 51.1781 39.234 53.7581 16.026 41.6821C0.554001 33.6331 4.07 24.9811 26.573 15.7281H26.574Z"
        fill="#F1F5FD"
      />
      <path
        opacity="0.8"
        d="M64.634 76.5078C80.0908 76.5078 92.621 73.6075 92.621 70.0298C92.621 66.4521 80.0908 63.5518 64.634 63.5518C49.1772 63.5518 36.647 66.4521 36.647 70.0298C36.647 73.6075 49.1772 76.5078 64.634 76.5078Z"
        fill="url(#paint0_linear_2101:231044)"
      />
      <path
        opacity="0.8"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M111.884 78.1127C90.841 83.3907 19.014 77.3537 11.369 74.5967C7.648 73.2537 4.294 70.7287 1.308 67.0207C0.973801 66.6061 0.763735 66.1054 0.702078 65.5765C0.640421 65.0475 0.729689 64.5119 0.959568 64.0316C1.18945 63.5512 1.55055 63.1457 2.00115 62.8619C2.45176 62.5781 2.97347 62.4276 3.506 62.4277H129.02C131.625 69.3657 125.913 74.5937 111.884 78.1127Z"
        fill="#F1F5FD"
      />
      <path
        d="M86.11 52.6692L76.539 41.4772C76.3127 41.2102 76.0314 40.9951 75.7144 40.8467C75.3973 40.6983 75.052 40.62 74.702 40.6172H54.122C53.416 40.6172 52.745 40.9412 52.285 41.4772L42.714 52.6692V58.8132H86.11V52.6692Z"
        fill="white"
      />
      <path
        d="M86.11 52.6692L76.539 41.4772C76.3127 41.2102 76.0314 40.9951 75.7144 40.8467C75.3973 40.6983 75.052 40.62 74.702 40.6172H54.122C53.416 40.6172 52.745 40.9412 52.285 41.4772L42.714 52.6692V58.8132H86.11V52.6692Z"
        fill="#3E4685"
      />
      <path
        d="M83.398 59.0395L75.021 49.2915C74.8185 49.0613 74.5688 48.8774 74.289 48.7523C74.0091 48.6272 73.7056 48.5639 73.399 48.5665H55.425C54.808 48.5665 54.205 48.8225 53.803 49.2915L45.426 59.0395V64.3935H83.398V59.0395Z"
        fill="#D1DCF2"
      />
      <path
        d="M86.11 65.8543C86.11 66.7073 85.726 67.4743 85.12 67.9883L84.997 68.0883C84.5165 68.4525 83.9299 68.6492 83.327 68.6483H45.498C45.156 68.6483 44.829 68.5863 44.527 68.4723L44.377 68.4123C43.8821 68.1922 43.4617 67.8333 43.1665 67.3791C42.8714 66.9249 42.7142 66.395 42.714 65.8533V52.7363H53.243C54.406 52.7363 55.343 53.6933 55.343 54.8543V54.8693C55.343 56.0313 56.291 56.9683 57.454 56.9683H71.37C71.929 56.9678 72.4651 56.7458 72.8607 56.3509C73.2564 55.956 73.4794 55.4203 73.481 54.8613C73.481 53.6953 74.419 52.7363 75.581 52.7363H86.111L86.11 65.8543Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M86.11 65.8543C86.11 66.7073 85.726 67.4743 85.12 67.9883L84.997 68.0883C84.5165 68.4525 83.9299 68.6492 83.327 68.6483H45.498C45.156 68.6483 44.829 68.5863 44.527 68.4723L44.377 68.4123C43.8821 68.1922 43.4617 67.8333 43.1665 67.3791C42.8714 66.9249 42.7142 66.395 42.714 65.8533V52.7363H53.243C54.406 52.7363 55.343 53.6933 55.343 54.8543V54.8693C55.343 56.0313 56.291 56.9683 57.454 56.9683H71.37C71.929 56.9678 72.4651 56.7458 72.8607 56.3509C73.2564 55.956 73.4794 55.4203 73.481 54.8613C73.481 53.6953 74.419 52.7363 75.581 52.7363H86.111L86.11 65.8543Z"
        fill="#3E4685"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2101:231044"
          x1="65.9483"
          y1="73.2184"
          x2="65.9483"
          y2="61.267"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DEDEDE" stop-opacity="0" />
          <stop offset="1" stop-color="#AFA7DC" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default EmptyBoxSvg
